module.exports = __webpack_public_path__ + "static/img/4216_phase_function_Paper_PointsHejduk_Prediction.4431d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4216_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Hu/v
// module chunks = 0